// extracted by mini-css-extract-plugin
module.exports =  {"metaIcon":"Wx8a1F8L4K8nNd97E6cK"};